import {registerRootComponent} from 'expo';
import React, {useEffect} from 'react';

import './global.js';

import {LogBox, Platform, View} from 'react-native';

import {useFonts} from 'expo-font';

import ReduxStore from 'src/Redux/ReduxStore';

import * as SplashScreen from 'expo-splash-screen';

import {QueryClient, QueryClientProvider} from '@tanstack/react-query';

console.log('app compliling');

LogBox.ignoreAllLogs();

import {StatusBar} from 'expo-status-bar';
import {GestureHandlerRootView} from 'react-native-gesture-handler';
import App from 'src/App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000, // 24 hours
    },
  },
});

SplashScreen.preventAutoHideAsync();

const Index = () => {
  console.log('Index.js is rendering');

  let [fontsLoaded] = useFonts({
    'CircularStd-Book': require('src/Fonts/CircularStd-Book.otf'),
    'CircularStd-Bold': require('src/Fonts/CircularStd-Bold.otf'),
    'Alternate Gothic No3 D': require('src/Fonts/AlternateGothic.otf'),
    Jakarta: require('src/Fonts/PlusJakartaSans.ttf'),
    JakartaBold: require('src/Fonts/PlusJakartaSansBold.ttf'),
  });

  console.log('fonts loaded');

  if (!fontsLoaded && Platform.OS !== 'web') {
    return <View></View>;
  }

  const GestureWrapper = Platform.OS != 'web' ? GestureHandlerRootView : View;

  return (
    <GestureWrapper style={{flex: 1, backgroundColor: global.color.orange}}>
      <QueryClientProvider client={queryClient} style={{flex: 1}}>
        <ReduxStore style={{flex: 1}}>
          <App />
        </ReduxStore>
      </QueryClientProvider>
      <StatusBar style="auto" />
    </GestureWrapper>
  );
};

registerRootComponent(Index);
